import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { evDate } from "@/lib/eventDate";

export const eventLabel = (e) => `${evDate(e)} · ${e.timeline_name}`;

export const EventPicker = ({ events, value, onChange, testid = "quote-events" }) => {
  const [q, setQ] = useState("");
  const k = q.toLowerCase();
  const shown = events.filter((e) => !k || e.title.toLowerCase().includes(k) || (e.display_date || "").toLowerCase().includes(k) || e.timeline_name.toLowerCase().includes(k));
  const toggle = (id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  return (
    <div className="rounded-md border border-[#2D3442] bg-[#0F131A]" data-testid={testid}>
      <Input className="h-9 rounded-none border-0 border-b" placeholder={value.length ? `${value.length} linked · filter ${events.length} events…` : `Filter ${events.length} events…`}
        value={q} onChange={(e) => setQ(e.target.value)} data-testid={`${testid}-filter`} />
      <div className="max-h-40 overflow-y-auto p-1 lf-scroll">
        {shown.length === 0 && <div className="p-3 text-xs text-[#A8A090]">No events.</div>}
        {shown.map((e) => (
          <label key={e.id} className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm hover:bg-[#1A202C]">
            <Checkbox checked={value.includes(e.id)} onCheckedChange={() => toggle(e.id)} data-testid={`${testid}-option-${e.id}`} />
            <span className="min-w-0 flex-1 truncate text-[#E8DFD1]">{e.title}</span>
            <span className="shrink-0 text-[10px] text-[#A8A090]">{eventLabel(e)}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
